(function($) {
	/**
	 * Update the price UI
	 * @param {String} element 
	 * @param {String} value 
	 * @param {String} currency 
	 */
	function updatePrice(element, value, currency) {
		document.querySelector(element).innerHTML = currency+value;
	}
	
  /**
	 * Price slider
	 */
	$('.js-range').each(function(i, el) {
		var min = Number(el.dataset.rangeMin);
		var max = Number(el.dataset.rangeMax);
		var minEl = el.dataset.rangeUiMin;
		var maxEl = el.dataset.rangeUiMax;
		var inputMinEl = el.dataset.rangeInputMin;
		var inputMaxEl = el.dataset.rangeInputMax;
		var currency = el.dataset.rangeCurrency;
		var step = el.dataset.rangeStep ? el.dataset.rangeStep : 100;

		function updateSlide(minValue, maxValue) {
			updatePrice(minEl, minValue, currency);
			updatePrice(maxEl, maxValue, currency);
			document.querySelector(inputMinEl).value = minValue;
			document.querySelector(inputMaxEl).value = maxValue;
		}
		
		$(el).slider({
			range: true,
			min: min,
			max: max,
			step: Number(step),
			values: [min, max],
			slide: (event, ui) => {
				updateSlide(ui.values[0], ui.values[1]);
			},
			change: (event, ui) => updateSlide(ui.values[0], ui.values[1]),
			stop(e, ui) {
				var target = $(el).parents('[data-noti-counter]').attr('data-noti-counter')
				! (ui.values[0] === min && ui.values[1] === max)
					? $(target).addClass('modified')
					: $(target).removeClass('modified')
			}
		});
		
		var inputValue = $(el).slider('option', 'values');
		updateSlide(inputValue[0], inputValue[1]);
	});
	
	/**
	 * Filter Panel
	 * @since 2019-02-28
	 */
	var filterPanel = {
		show: function() {
			$('body').addClass('filter-panel-show');
		},
		hide: function() {
			$('body').removeClass('filter-panel-show');
		},
		toggle: function() {
			return this._state() ? this.hide() : this.show();
		},
		_state: function() {
			return $('body').hasClass('filter-panel-show');
		}
	};

	$(document).on('click', '.js-filter-panel', function(event) {
		event.preventDefault();
		filterPanel.toggle();
	});

	$(document).on('click', '.js-filter-panel-hide', function(event) {
		event.preventDefault();
		filterPanel.hide();
	});

	window.addEventListener('resize', function() {
		if (window.innerWidth >= 950)
			filterPanel.hide();
	}.throttle(16));

	/**
	 * Recalcurate position of arrow
	 * @since 2019-03-28
	 */
	function blockRateArrow() {
		var $blocks = $('.block-thumbnail.active');

		if ($blocks.length) {
			$blocks.each((i, el) => {
				var itemId = el.dataset.itemId;
				var $thumb = $(`[data-item-id=${itemId}]`).filter('.block-thumbnail');
				var $rates = $(`[data-item-id=${itemId}]`).filter('.block-content');
				var $arrow = $rates.find('.block-content__arrow');
				var position = $thumb.width() / 2 + $thumb.position().left;
				$arrow.css('left', position);
			});
		}
	}
        
        if (typeof window.TL.ui.BlockRateArrow === 'undefined') {
            window.TL.ui.BlockRateArrow = blockRateArrow;
        }

	/**
	 * Control items to show or hide or toggle display
	 * @param {String} itemId 
	 * @param {String} method show | hide | toggle
	 */
	function blockRateControl(itemId, method, animate) {
		var mtd = method || 'toggle';
		var ani = animate !== undefined ? animate : true;
		var $target = $(`[data-item-id=${itemId}]`);
		var $thumb = $target.filter('.block-thumbnail');
		var $rate = $target.filter('.block-content');
		var options = {
			show: function() {
				$thumb.addClass('active');
				$rate.addClass('active').collapse('show');

				if (!ani) {
					$thumb.addClass('no-animation');
					$rate.addClass('no-animation');
					setTimeout(() => {
						$thumb.removeClass('no-animation');
						$rate.removeClass('no-animation');
					}, 350);
				}

				setTimeout(() => {
					blockRateArrow();
				}, 0);
			},
			hide: function() {
				$thumb.removeClass('active');
				$rate.removeClass('active').collapse('hide');

				if (!ani) {
					$thumb.addClass('no-animation');
					$rate.addClass('no-animation');
					setTimeout(() => {
						$thumb.removeClass('no-animation');
						$rate.removeClass('no-animation');
					}, 350);
				}
			},
			toggle: function() {
				if (this._state() === 'show') {
					this.hide();
				} else {
					this.show();
				}
			},
			_state: function() {
				return $thumb.hasClass('active') ? 'show' : 'hide';
			}
		};

		options[mtd]();

		return {
			thumb: $thumb.get(0),
			content: $rate.get(0)
		};
	}

	window.addEventListener('resize', function() {
		blockRateArrow();
	}.throttle(16));

	/**
	 * Filter Form Submit
	 * @since 2019-03-01
	 */
//	const $filterForm = $('#filter_form');
//	$filterForm.on('change', function(event) {
//		var data = $(this).serializeArray();
//
//		data.forEach(function(el) {
//			switch (el.name) {
//				case 'show_by':
//					$('.js-result').attr('data-list-type', el.value);
//					if (el.value === 'rates') {
//						$('[for="filter_grid_columns"], [for="filter_columns"]').css('display', 'none')
//					} else {
//						$('[for="filter_grid_columns"], [for="filter_columns"]').css('display', '')
//					}
//					break;
//				case 'view_by':
//					$('.js-result').attr('data-list-view', el.value);
//					break;
//			}
//		});
//
//		if (['show_by','view_by'].indexOf(event.target.name) > -1) {
//			blockRateArrow();
//		}
//	}).trigger('change');

	/**
	 * Item toggle button's behavior
	 * @since 2019-03-28
	 */
	$(document).on('click', '[data-item-toggle]', function(event) {
		event.preventDefault();

		var itemId = this.dataset.itemToggle;
		var $buttons = $('[data-item-toggle]');

		if (!$(this).hasClass('pending')) {
			blockRateControl(itemId);

			$buttons.addClass('pending');
			setTimeout(function() {
				$buttons.removeClass('pending');
			}, 350);
		}
	});

	/**
	 * Close another when open the item by same type of view
	 * @since 2019-03-28
	 */
        const blockContentInit = function() {
            $('.block-content').on('show.bs.collapse', function(event) {
                    if ($(event.target).is('.block-content')) {
                            var $parent = $(this).closest('.list-result');
                            $parent.find('.block-content').not(this).each(function(i, el) {
                                    var $target = $(`[data-item-id=${el.dataset.itemId}]`);
                                    $target.filter('.block-thumbnail').removeClass('active');
                                    $target.filter('.block-content').removeClass('active').collapse('hide');
                            });
                    }
            });
        };
        
        if(typeof window.TL.ui.BlockContentInit === 'undefined') {
            window.TL.ui.BlockContentInit = blockContentInit;
        }
        
        window.TL.ui.BlockContentInit();
        
	/**
	 * Control the contents what to show by default
	 * @note 1 Block/Type
	 * @since 2019-03-28
	 */
	window.addEventListener('load', function() {
		$('[data-list-show]').each(function(i, el) {
			var list = el.dataset.listShow;
			var items = list.trim().split(' ');
			items.forEach(function(itemId) {
				blockRateControl(itemId, 'show', false);
			});
		});
	});
	
	/**
	 * Control limit of rate items display by default in each blocks
	 * @since 2019-03-28
	 */
        
        const blockRateInit = function() {
            $('.block-rates').each(function() {
                    var limit = this.dataset.limit;
                    var $items = $(this).find('.rate-item');
                    var length = $items.length;

                    for (var i = 0; i < limit; i++) {
                            $items.eq(i).addClass('show');
                    }

                    var $toggle = $(this).parent().find('.js-rates-toggle');

                    if (0 < length - limit) {
                            $toggle.css('display', 'block');
                            $toggle.attr('data-text-show', function() {
                                    var text = this.dataset.textShow;
                                    return text.replace(/%num_of_items/g, length - limit);
                            });
                    }
            });
        }
        
        if (typeof window.TL.ui.BlockRateInit === 'undefined') {
            window.TL.ui.BlockRateInit = blockRateInit;
        }
        
        window.TL.ui.BlockRateInit();
        
	/**
	 * Rate toggle button's behavior
	 * @since 2019-03-28
	 */
	$(document).on('click', '.js-rates-toggle', function(event) {
		event.preventDefault();
		var $btn = $(this);
		var $par = $btn.parent().find('.block-rates');
		var limit = $par.data('limit');
		var $items = $par.find('.rate-item');
		var length = $items.length;
		var i = limit;

		if ($btn.hasClass('collapsed')) {
			$btn.removeClass('collapsed');
			for (i; i < length; i++) {
				$items.eq(i).collapse('show');
			}
		} else {
			$btn.addClass('collapsed');
			for (i; i < length; i++) {
				$items.eq(i).collapse('hide');
			}
		}
	});

        /**
	 * Benefit list toggle between full-list and less-list
	 * @since 2019-10-09
	 */
	$(document).on('click', '.js-benefits-accordion', function(event) {
		event.preventDefault();
		var $parent = $(this).parents('.row-benefits')
		var $less = $parent.find('.benefits-less')
		var $full = $parent.find('.benefits-full')
		if ($less.hasClass('show')) {
			$less.collapse('hide').attr('aria-expanded', false)
			$full.collapse('show').attr('aria-expanded', true)
		} else {
			$less.collapse('show').attr('aria-expanded', true)
			$full.collapse('hide').attr('aria-expanded', false)
		}
	})

	/**
	 * Detail toggle button's behavior
	 * @since 2019-03-28
	 */
	$(document).on('click', '.js-detail-toggle', function(event) {
		event.preventDefault();
		var $parent = $(this).closest('.rate-item');
		var $buttons = $parent.find('.js-detail-toggle');
		var $contents = $parent.find('.js-detail-content');
		$contents.each(function(i, el) {
			var $content = $(el);
			if (!$content.hasClass('show')) {
				$content.collapse('show');
				$buttons.removeClass('collapsed');
			} else {
				$content.collapse('hide');
				$buttons.addClass('collapsed');
			}
		});
	});

	/**
	 * Get coordinate of element
	 * @param {Object.element} element 
	 */
	function getElementRect(element) {
		var el = element.getBoundingClientRect();
		var winY = window.scrollY || window.pageYOffset;
		return {
			w: el.width,
			h: el.height,
			x: Math.round(el.left),
			y: Math.round(el.top + winY)
		}
	}

	/**
	 * Get value by min-max scope
	 * @param {Number} min 
	 * @param {Number} max 
	 * @param {Number} val 
	 */
	function getMinMax(min, max, val) {
		return Math.max(min, Math.min(max, val));
	}

	/**
	 * Get the hidden element's dimensions
	 */
	$.fn.getHiddenElementDimension = function(childSelector) {
		var $clone = this.clone().appendTo('body');
		$clone.css({
			position: 'absolute',
			zIndex: '-99',
			top: '-9999px',
			left: '-9999px',
			display: 'block',
			visibility: 'hidden'
		});

		var $el = childSelector ? $clone.find(childSelector) : $clone;
		var w = Math.round($el.innerWidth());
		var h = Math.round($el.innerHeight());
		$clone.remove();

		this.attr({
			'data-element-width': w,
			'data-element-height': h
		});

		return {
			width: w,
			height: h
		}
	}

	/**
	 * jQuery slide options
	 * @update 2019-09-11
	 * @note Use to simuldate dropdown collapse like bootstrap's collapse
	 */
	var slideOpts = {
		duration: 350,
		easing: 'easeOutCubic'
	};

	/**
	 * Quick Filter Init
	 * @since 2019-09-11
	 */
	function quickFilterInit( opts ) {
		var slideOpts = $.extend({
			duration: 350,
			easing: 'easeOutCubic'
		}, opts);

		var $qf = $('.quick-filter');
		var $qfw = $qf.find('.quick-filter__items-wrapper');

		if ($qf.length) {
			var qfw = $qfw[0]
			
			// Sum of filter items' width
			var filterItemsWidth = function() {
				var w = 0;
				var gap = 2.8 * 2;
				$qf.find('.filter-group').each((i, el) => w += $(el).outerWidth(true));
				return Math.floor(w + gap);
			}
			
			// Check and show navigation arrows as need
			var filterScrollDetect = function() {
				if (!qfw) return;

				var scrollable = qfw.clientWidth < filterItemsWidth()
				scrollable
					? $qf.addClass('quick-filter--scrollable')
					: $qf.removeClass('quick-filter--scrollable');

				var detected = new CustomEvent('filterScrollDetected', {
					detail: {
						scrollable: scrollable,
						scrollWidth: qfw.clientWidth,
						itemsWidth: filterItemsWidth()
					}
				});

				qfw.dispatchEvent(detected);
			}
			
			// Check and set state of arrows
			var filterNavigationState = function() {
				var w = qfw.scrollWidth;
				var x = qfw.scrollLeft;
				var $prev = $('.quick-filter__nav-prev');
				var $next = $('.quick-filter__nav-next');
		
				if (0 === x) {
					$qf.addClass('no-prev');
					$prev.addClass('disabled');
				} else if (x + qfw.clientWidth === w) {
					$qf.addClass('no-next');
					$next.addClass('disabled');
				} else {
					$qf.removeClass('no-prev no-next');
					$prev.removeClass('disabled');
					$next.removeClass('disabled');
				}
			}

			$qf.on('click', '.quick-filter__nav', function(event) {
				event.preventDefault();
	
				if ($(event.currentTarget).is('.quick-filter__nav-prev')) {
					qfw.scrollBy({
						top: 0,
						left: qfw.clientWidth * 0.67 * -1,
						behavior: 'smooth'
					});
				} else if ($(event.currentTarget).is('.quick-filter__nav-next')) {
					qfw.scrollBy({
						top: 0,
						left: qfw.clientWidth * 0.67,
						behavior: 'smooth'
					});
				}
			});

			$qf.on('click', 'button.filter-panel-toggle', function(event) {
				event.preventDefault();
	
				var btn = this;
				var panel = document.querySelector(btn.dataset.target);
				var shadow = 20;
				var border = 2.8;
				var offset = shadow + border;
				var min = 0;
				var max = Math.abs(qfw.scrollWidth - qfw.clientWidth);
				var target = btn.offsetLeft - offset;
				var toTarget = getMinMax(min, max, target);
				var distance = Math.abs(toTarget - qfw.scrollLeft);
	
				$qfw.animate({
					scrollLeft: toTarget,
				}, {
					duration: distance * 2,
					complete: function() {
						if ($(panel).hasClass('show')) {
							$(panel).stop().slideUp(slideOpts).removeClass('show');
							$(btn).addClass('collapsed').attr('aria-expanded', false);
							$(document).off('click.filter');
						} else {
							var coordinate = getElementRect(btn);
							
							panel.style.top = coordinate.y + coordinate.h + 'px';
							panel.style.left = coordinate.x + coordinate.w / 2 - panel.dataset.elementWidth / 2 + 'px';
	
							setTimeout(() => {
								$(panel).slideDown(slideOpts).addClass('show');
								$(btn).removeClass('collapsed').attr('aria-expanded', true);
								$(document).on('click.filter', function(event) {
									if (!$(event.target).closest([btn, panel]).length) {
										$(btn).addClass('collapsed').attr('aria-expanded', false);
										$(panel).stop().slideUp(slideOpts).removeClass('show');
										$(document).off('click.filter');
									}
								});
							}, 100);
						}
					}
				});
			});

			window.addEventListener('load', filterScrollDetect);
			window.addEventListener('resize', filterScrollDetect.debounce(50));
			window.addEventListener('resize', function() {
				$('.filter-panel-toggle').addClass('collapsed').attr('aria-expanded', false).off('click.filter');
				$('.quick-filter__dropdown-group .collapse').css('display', 'none').removeClass('show');
			}.throttle(16));

			qfw.addEventListener('filterScrollDetected', filterNavigationState);
			qfw.addEventListener('scroll', function() {
				filterNavigationState();
				$('.filter-panel-toggle').addClass('collapsed').attr('aria-expanded', false).off('click.filter');
				$('.quick-filter__dropdown-group .collapse').slideUp(slideOpts).removeClass('show');
			}.throttle(16));

			$('.quick-filter__dropdown-group .quick-filter__dropdown').each(function() {
				$(this).getHiddenElementDimension('.inner');
			});
		}
                initQuickFilterArrowSpan();
	}

	quickFilterInit(slideOpts);

	/**
	 * Register quickFilterInit() to global
	 * @update 2019-09-11
	 */
	if (window.TL.ui.QuickFilterInit === undefined) {
		window.TL.ui.QuickFilterInit = quickFilterInit;
	}

	/**
	 * Bind click event for "all_filter" dropdown button
	 * @update 2019-09-11
	 */
	$(document).on('click', '#all_filter_dropdown_toggle', function(event) {
		event.preventDefault();

		var btn = this;
		var panel = document.querySelector(btn.dataset.target);
		var methods = {
			show: function() {
				var coordinate = getElementRect(btn);

				panel.style.top = coordinate.y + coordinate.h + 'px';
				panel.style.left = coordinate.x + coordinate.w - panel.dataset.elementWidth + 'px';
				panel.querySelector('.arrow').style.left = Math.round(panel.dataset.elementWidth - coordinate.w / 2) + 'px';

				$(panel).slideDown(slideOpts).addClass('show');
				$(btn).removeClass('collapsed').attr('aria-expanded', true);
				$(document).on('click.filterAll', function(event) {
					if (!$(event.target).closest([btn, panel]).length) {
						methods.hide();
					}
				});
			},
			hide: function() {
				$(panel).stop().slideUp(slideOpts).removeClass('show');
				$(btn).addClass('collapsed').attr('aria-expanded', false);
				$(document).off('click.filterAll');
			}
		}

		if ($(panel).hasClass('show')) {
			methods.hide();
		} else {
			methods.show();
		}
	});

        /**
        * Automatic add arrow into all filter panel
        * @update 2019-09-11
        */
        function initQuickFilterArrowSpan() {
            $('.quick-filter__dropdown').each(function () {
             // Don't need to add arrow if exists
             if (this.querySelector('span.arrow')) return;
             var arrow = document.createElement('span');
             arrow.classList.add('arrow');
             arrow.setAttribute('aria-hidden', true);
             this.insertAdjacentHTML('beforeend', arrow.outerHTML);
           });
        }

        initQuickFilterArrowSpan();

	/**
	 * Update filter counter on form changed
	 * @since 2019-05-27
	 */
	$('[data-noti-counter]').each(function() {
		var _self = this;
		var target = _self.getAttribute('data-noti-counter');
		var $inp = $(_self).find('input');
		$inp.on('change', () => {
			var checked = $(_self).find('input:checked').length
			checked === 0
				? $(target).removeClass('modified')
				: $(target).addClass('modified')
			$(target).text(checked > 0 ? checked : '')
		})
	})
})(jQuery);